import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
export class GameSoundEvent {
}
GameSoundEvent.DAB_SWOOSH = new EventObject("GameSoundEvent.DAB_SWOOSH");
GameSoundEvent.SUSPENSE_WIN_LINE = new EventObject("GameSoundEvent.SUSPENSE_WIN_LINE");
GameSoundEvent.WIN_LINE_COMPLETE = new EventObject("GameSoundEvent.WIN_LINE_COMPLETE");
GameSoundEvent.WIN_LINE_INCREASE = new EventObject("GameSoundEvent.WIN_LINE_INCREASE");
GameSoundEvent.WIN_LINE_FIREWORK = new EventObject("GameSoundEvent.WIN_LINE_FIREWORK");
GameSoundEvent.WIN_LINE_COUNT_UP = new EventObject("GameSoundEvent.WIN_LINE_COUNT_UP");
GameSoundEvent.WIN_LINE_COUNT_UP_END = new EventObject("GameSoundEvent.WIN_LINE_COUNT_UP_END");
GameSoundEvent.LADDER_NOTE = new EventObject("GameSoundEvent.LADDER_NOTE");
GameSoundEvent.FIREWORK_LOOP = new EventObject("GameSoundEvent.FIREWORK_LOOP");
GameSoundEvent.FIREWORK_LOOP_END = new EventObject("GameSoundEvent.FIREWORK_LOOP_END");
GameSoundEvent.SCATTER_SYMBOL_WIN = new EventObject("GameSoundEvent.SCATTER_SYMBOL_WIN");
GameSoundEvent.COCONUT_APPEAR = new EventObject("GameSoundEvent.COCONUT_APPEAR");
GameSoundEvent.COCONUT_ORBIT = new EventObject("GameSoundEvent.COCONUT_ORBIT");
GameSoundEvent.COCONUT_PLAYER_TAP = new EventObject("GameSoundEvent.COCONUT_PLAYER_TAP");
GameSoundEvent.COCONUT_CRACK = new EventObject("GameSoundEvent.COCONUT_CRACK");
GameSoundEvent.COCONUT_EXPLODE = new EventObject("GameSoundEvent.COCONUT_EXPLODE");
GameSoundEvent.COCONUT_EXPLODE_REVEAL = new EventObject("GameSoundEvent.COCONUT_EXPLODE_REVEAL");
GameSoundEvent.COCONUT_BUILDUP = new EventObject("GameSoundEvent.COCONUT_BUILDUP");
//# sourceMappingURL=GameSoundEvent.js.map